import template from './template.html'

export default {
  restrict: 'E',
  template,
  bindings: {
    storyObj: '=',
    authorObj: '=',
    companySettings: '=',
    picklists: '=',
    websitesObj: '=',
    errorCapture: '&',
    updateModel: '&',
    meta: '=',
  },
  controllerAs: 'vm',
  controller: 'PlanningBodyController',
}
